import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p>Welcome to Clean Code Engineer. By using our platform, you agree to the following terms and conditions:</p>
      <ol>
        <li><strong>Account Responsibility:</strong> You are responsible for maintaining the confidentiality of your account information.</li>
        <li><strong>Acceptable Use:</strong> Use our services for lawful purposes only. Do not misuse or attempt to disrupt our platform.</li>
        <li><strong>Content Ownership:</strong> All content, courses, and materials are the property of Clean Code Engineer or its licensors.</li>
        <li><strong>Privacy:</strong> Your personal information is handled according to our Privacy Policy.</li>
        <li><strong>Changes to Terms:</strong> We may update these terms at any time. Continued use of the platform means you accept the changes.</li>
        <li><strong>Termination:</strong> We reserve the right to suspend or terminate accounts that violate these terms.</li>
      </ol>
      <h2>Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us at <a href="mailto:support@cleancodeeng.com" className="terms-link">support@cleancodeeng.com</a>.</p>
    </div>
  );
};

export default TermsOfService;
